{ "name": "dusk", "sunDir": [0.82, 0.30, 0.48], "sunColor": "#FFB88A", "sunIntensity": 2.1,
  "skyColor": "#A9A8D8", "groundColor": "#6E6478", "hemiIntensity": 0.95,
  "hazeAmount": 0.16, "tint": "#FFD0B0", "tintAmount": 0.08, "valueScale": 0.93 }
